import { Screen } from '~/screens/contract-plans/[planId]';

export const ContractPlanDetailIndex: React.FC = () => <Screen />;
